module.exports = __webpack_public_path__ + "img/error.807d632d.png";